/**
 * Desktop #FacetFiltersForm: replaces native <details> with div + button toggles (.is-open).
 */
(function () {
  const FORM_SELECTOR = '#FacetFiltersForm';

  function facetRoot(el) {
    return el.closest(`${FORM_SELECTOR} .js-filter`);
  }

  function panelForRoot(root) {
    return root.querySelector('.facets__display, .facets__display-vertical');
  }

  function setOpen(root, open) {
    root.classList.toggle('is-open', open);
    const btn = root.querySelector('[data-facet-toggle]');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    const panel = panelForRoot(root);
    if (panel) panel.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  document.addEventListener('click', function (event) {
    const btn = event.target.closest(`${FORM_SELECTOR} [data-facet-toggle]`);
    if (!btn) return;

    const root = facetRoot(btn);
    if (!root) return;

    event.preventDefault();
    const opening = !root.classList.contains('is-open');
    setOpen(root, opening);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll(`${FORM_SELECTOR} .js-filter.is-open`).forEach((root) => setOpen(root, false));
  });
})();
